import { CounterComponent } from './counter.component';
import { Ng9OdometerModule } from 'ng9-odometer';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [CounterComponent],
	imports: [CommonModule, Ng9OdometerModule.forRoot()],
	exports: [CounterComponent],
})
export class CounterModule {}
